export var CLASS_REPOSITORY = 'CLASS_REPOSITORY';